import { NgOptimizedImage, CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject, LOCALE_ID, model } from "@angular/core";
import { ActivationEnd, Router, RouterModule } from "@angular/router";
import { ContactUsFormComponent } from "./components/contact-us-form/contact-us-form.component";
import { NavbarComponent } from "./components/navbar/navbar.component";
import { ContactUsDialogService } from "./contact-us-dialog.service";
import { LanguageSelectorComponent } from "./language-selector.component";
import { AnalyticsService } from "./ga.service";
import { ConfigService } from "./config.service";
declare let gtag: any;

@Component({
    imports: [RouterModule, CommonModule, NgOptimizedImage, LanguageSelectorComponent, ContactUsFormComponent, NavbarComponent],
    selector: "in2-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
    private readonly router = inject(Router);
    readonly contactUsDialogService = inject(ContactUsDialogService);
    currentLanguage = model<string>(inject(LOCALE_ID));
    navbarClass = model<string>("app-nav transparent");
    private analytics = inject(AnalyticsService);
    private readonly configService = inject(ConfigService);

    async ngOnInit() {
        this.router.events.subscribe((e) => {
            if (e instanceof ActivationEnd) {
                const { navbarClass } = e.snapshot.data;
                this.navbarClass.set(navbarClass ?? "");
            }
        });
        const key = await this.configService.get("GA_TRACKING_CODE");
        if (key) {
            this.analytics.init(key);
        }
    }

    year = new Date().getFullYear();
}
